module.exports = __webpack_public_path__ + "static/mob_promo-32d63c0b37b55e6ad1fdd2f1e7a286f3.png";